
  import $ from "jquery";
  import moment from "moment";
  import VueApexCharts from "vue-apexcharts";
  import { servicesExtensions } from "../../../_helpers/servicesExtensions";
  import CapsuleMultiselect from "../../../components/view_elements/CapsuleMultiselect.vue";
  import FilterDropdown from "../../../components/view_elements/FilterDropdown.vue";
  import config from "../../../config";
  import cspMixin from "../../../mixins/cspMixin";

  const thStyle = {
    color: "var(--main-bg-color)",
    textAlign: "left",
    lineHeight: "13px"
  };

  export default {
    name: servicesExtensions.cspPanel.extensions.cspDashboard.name
      .toLowerCase()
      .replace(/\s+/g, ""),
    mixins: [cspMixin],
    components: {
      CapsuleMultiselect,
      FilterDropdown,
      apexchart: VueApexCharts
    },
    data() {
      return {
        loadedData: false,
        showLoading: false,
        loadingIntervalId: undefined,
        loadedResources: false,
        loadedProductSkus: false,
        azureResourcesChartKey: 0,
        licencesUsageChartKey: 0,
        tenantSelected: undefined,
        tenants: [],
        azPlanSelectedId: undefined,
        azPlanSelectedName: undefined,
        selectedAzPlanIndex: undefined,
        resourceGroupsSearchFilter: "",
        resourceGroupsSubscriptionFilter: [],
        licencesTableData: [],
        estimatedCost: undefined,
        licencesChartLegendSquares: ["#12b3db", "#ff9a27", "#00c37b"],
        textLoading: "",
        subscriptionsTypeCount: 0,
        licencesCount: 0,
        azurePlansCount: 0,
        billingPeriod: "",
        billingDaysRemaining: undefined,
        monthlyBudget: "",
        azurePlansCost: "",
        azurePlansUsagePercentage: "",
        azurePlansTableData: [],
        azurePlanSubscriptionsTableData: [],
        azureResourceGroupsTableData: [],
        text: {
          loading: this.$t("loading"),
          selectTenant: this.$t("selectTenant"),
          directory: this.$t("directory"),
          tenant: this.$tc("tenant", 1),
          cspWarningBanner: this.$t("cspWarningBanner"),
          typeSubscriptions: this.$tc("typeSubscriptions", 2),
          azurePlansCSP: this.$t("azurePlansCSP"),
          currentEstimatedCost: this.$t("currentEstimatedCost"),
          licencesCSP: this.$t("licencesCSP"),
          licencesChartLegend: [
            this.$t("activeCSP"),
            this.$t("consumedCSP"),
            this.$t("availableCSP")
          ],
          licencesBreakdownCard: this.$t("licencesBreakdownCard"),
          licencesUsageChart: this.$t("licencesUsageChart"),
          azurePlansCard: this.$t("azurePlansCard"),
          billingPeriod: this.$t("billingPeriod"),
          daysRemaining: this.$t("daysRemaining"),
          monthlyBudget: this.$t("monthlyBudget"),
          currentEstimatedCostLC: this.$t("currentEstimatedCostLC"),
          percentageBudget: this.$t("percentageBudget"),
          azurePlanSubscriptions: this.$t("azurePlanSubscriptions"),
          azurePlanResources: this.$t("azurePlanResources"),
          resourceGroupCosts: this.$t("azurePlanResourceGroups"),
          resourceGroup: this.$t("resourceGroup")
        },
        licencesUsageChart: {
          width: "100%",
          series: [
            {
              name: this.$t("activeCSP"),
              data: []
            },
            {
              name: this.$t("consumedCSP"),
              data: []
            },
            {
              name: this.$t("availableCSP"),
              data: []
            }
          ],
          chartOptions: {
            colors: ["#12b3db", "#ff9a27", "#00c37b"],
            chart: {
              type: "bar"
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "60%",
                borderRadius: 5,
                borderRadiusApplication: "end",
                dataLabels: {
                  position: "top"
                }
              }
            },
            dataLabels: {
              enabled: true,
              style: {
                colors: ["#000"],
                fontWeight: "normal"
              },
              position: "top",
              offsetY: -25
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["transparent"]
            },
            xaxis: {
              labels: {
                rotate: 0,
                hideOverlappingLabels: false,
                trim: true
              },
              categories: []
            },
            yaxis: {
              labels: {
                show: false
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val;
                }
              }
            }
          }
        },
        licencesUsageMockedChart: {
          series: [
            {
              name: this.$t("activeCSP"),
              data: [76, 85, 101, 98, 87, 105, 91, 114]
            },
            {
              name: this.$t("consumedCSP"),
              data: [44, 55, 57, 56, 61, 58, 63, 60]
            },
            {
              name: this.$t("availableCSP"),
              data: [32, 30, 44, 42, 26, 47, 28, 54]
            }
          ],
          chartOptions: {
            chart: {
              type: "bar",
              height: 350
            },
            legend: {
              position: "top",
              fontFamily: "Ubuntu, sans-serif"
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "55%",
                borderRadius: 5,
                borderRadiusApplication: "end"
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ["transparent"]
            },
            xaxis: {
              categories: [
                "Sub 1",
                "Sub 2",
                "Sub 3",
                "Sub 4",
                "Sub 5",
                "Sub 6",
                "Sub 7",
                "Sub 8"
              ]
            },
            yaxis: {
              labels: {
                show: false
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              enabled: false
            }
          }
        },
        licencesTableNames: [
          {
            label: this.$t("subscriptionCSP"),
            key: "subscription",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "25%", ...thStyle }
          },
          {
            label: this.$t("quantity"),
            key: "quantity",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "15%", ...thStyle }
          },
          {
            label: this.$t("unitCost"),
            key: "unitCost",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "15%", ...thStyle }
          },
          {
            label: this.$t("cost"),
            key: "cost",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "15%", ...thStyle }
          },
          {
            label: this.$t("status"),
            key: "status",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "30%", ...thStyle }
          }
        ],
        azurePlansTableNames: [
          {
            label: this.$t("name"),
            key: "azPlanName",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "25%", ...thStyle }
          },
          {
            label: this.$t("currentCost"),
            key: "azPlanCost",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "25%", ...thStyle }
          },
          {
            label: this.$t("percentageBudget"),
            key: "azPlanPercentageBudget",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "25%", ...thStyle }
          },
          {
            label: this.$t("status"),
            key: "azPlanStatus",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "20%", ...thStyle }
          },
          {
            label: "",
            key: "azPlanSelection",
            sortable: false,
            thClass: "position-sticky",
            thStyle: { width: "5%", ...thStyle }
          }
        ],
        azurePlanSubscriptionsTableNames: [
          {
            label: this.$t("azureSubscriptionName"),
            key: "azPlanSubscriptionName",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "50%", ...thStyle }
          },
          {
            label: this.$t("status"),
            key: "azPlanSubscriptionStatus",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "20%", ...thStyle }
          },
          {
            label: this.$t("currentCost"),
            key: "azPlanSubscriptionCost",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "30%", ...thStyle }
          }
        ],
        azureSubscriptionResourceGroupTableNames: [
          {
            label: this.$t("resourceGroup"),
            key: "resourceGroupName",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "70%", ...thStyle }
          },
          {
            label: this.$t("currentCost"),
            key: "resourceGroupCost",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "30%", ...thStyle }
          }
        ],
        azureResourceGroupsTableNames: [
          {
            label: this.$t("resourceGroup"),
            key: "resourceGroupName",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "50%", ...thStyle }
          },
          {
            label: this.$t("subscription"),
            key: "resourceGroupSubscriptionName",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "20%", ...thStyle }
          },
          {
            label: this.$t("currentCost"),
            key: "resourceGroupCost",
            sortable: true,
            thClass: "position-sticky",
            thStyle: { width: "30%", ...thStyle }
          }
        ],
        azureResourcesChart: {
          height: "100%",
          series: [
            {
              name: this.$t("currentCost"),
              data: []
            }
          ],
          chartOptions: {
            chart: {
              type: "bar"
            },
            colors: ["#0070ad"],
            plotOptions: {
              bar: {
                height: "30%",
                borderRadius: 2,
                horizontal: true,
                endingShape: "rounded",
                dataLabels: {
                  position: "top"
                }
              }
            },
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                if (val < 0.01) {
                  return "< €0.01";
                }
                return `€${val}`;
              },
              style: {
                colors: ["#000"]
              },
              offsetX: 30
            },
            xaxis: {
              categories: [],
              labels: {
                show: false
              }
            },
            yaxis: {
              labels: {
                maxWidth: 220,
                offsetY: 4
              }
            }
          }
        },
        azureResourcesMockedChart: {
          series: [
            {
              name: this.$t("currentCost"),
              data: [
                98.76, 91.23, 88.12, 87.45, 76.89, 73.45, 67.89, 62.34, 54.32,
                49.87, 45.21, 41.78, 38.45, 33.44, 29.56, 26.78, 23.67, 19.23,
                15.67, 12.34
              ]
            }
          ],
          chartOptions: {
            chart: {
              type: "bar"
            },
            colors: ["#0070ad"],
            plotOptions: {
              bar: {
                borderRadius: 2,
                horizontal: true,
                endingShape: "rounded",
                dataLabels: {
                  position: "top"
                }
              }
            },
            dataLabels: {
              enabled: true,
              style: {
                colors: ["#000"],
                fontWeight: "normal"
              },
              offsetX: 30
            },
            xaxis: {
              categories: [
                "Azure Resource 1",
                "Azure Resource 2",
                "Azure Resource 3",
                "Azure Resource 4",
                "Azure Resource 5",
                "Azure Resource 6",
                "Azure Resource 7",
                "Azure Resource 8",
                "Azure Resource 9",
                "Azure Resource 10",
                "Azure Resource 11",
                "Azure Resource 12",
                "Azure Resource 13",
                "Azure Resource 14",
                "Azure Resource 15",
                "Azure Resource 16",
                "Azure Resource 17",
                "Azure Resource 18",
                "Azure Resource 19"
              ],
              labels: {
                show: false
              }
            },
            yaxis: {
              labels: {
                offsetY: 4
              }
            },
            tooltip: {
              enabled: false
            }
          }
        }
      };
    },
    async created() {
      if (this.getUserPermissions.csp.read) {
        this.addLoadingComponent(this.$options.name);
        this.tenants = this.tenantList();
        this.tenantSelected = this.tenants[0];
        this.cacheLocalStorage(this.tenantSelected.id);
        await this.setData();
      }
    },
    async mounted() {
      this.$emit("projectHeaderService", servicesExtensions.cspPanel.name);
      this.$emit(
        "projectHeaderExtension",
        servicesExtensions.cspPanel.extensions.cspDashboard.name
      );
    },
    methods: {
      cacheLocalStorage(tenant) {
        localStorage.setItem(
          `lastVisitedTenantCSP_${this.$route.params.projectId}`,
          tenant
        );
      },
      /* KPI cards */
      setSubscriptionTypesCount() {
        this.subscriptionsTypeCount = this.getSubscriptionsCSP(
          this.tenantSelected.id
        ).length;
      },
      setLicencesCount() {
        let totalCount = 0;
        for (const sub of this.getNonAzurePlanSubscriptionsCSP(
          this.tenantSelected.id
        )) {
          totalCount += sub.quantity;
        }
        this.licencesCount = totalCount;
      },
      setAzurePlansCount() {
        this.azurePlansCount = this.getAzurePlanSubscriptionsCSP(
          this.tenantSelected.id
        ).length;
      },
      async setEstimatedCost() {
        this.estimatedCost = (
          await this.getEstimatedCost(this.tenantSelected.id)
        ).toFixed(2);
      },
      /* Tenant selection */
      tenantList() {
        const list = [];
        if (config.prodEnv) {
          const tenantsCSV = this.getClients.find(
            e =>
              e.id == this.getProjectById(this.$route.params.projectId).clientId
          ).tenant;
          if (tenantsCSV) {
            const tenantsIds = tenantsCSV.split(",");
            for (const tenantId of tenantsIds) {
              list.push(this.getCustomerCSP(tenantId));
            }
          }
        } else {
          list.push({
            id: "b3729cd9-53b3-4abd-b7fe-3dbbcb5ea489",
            name: "CSP Dashboard"
          });
          list.push({
            id: "667d438b-32ec-4266-b952-0458fae25c90",
            name: "Sogeti POC"
          });
          list.push({
            id: "a1e4d903-c0a4-4917-8d17-9a8e09c3ea9b",
            name: "CSPSBX Dashboard"
          });
        }
        return list;
      },
      async tenantSelect(tenant) {
        this.startLoading();
        this.tenantSelected = tenant;
        this.cacheLocalStorage(tenant.id);
        await this.setData();
      },
      startLoading() {
        this.showLoading = true;
        let numDots = 0;
        this.loadingIntervalId = setInterval(() => {
          numDots = (numDots % 3) + 1;
          this.textLoading = this.text.loading + ".".repeat(numDots);
        }, 1000);
      },
      stopLoading() {
        this.showLoading = false;
        clearInterval(this.loadingIntervalId);
      },
      /* Set & load data */
      async setData() {
        try {
          await this.loadVuexStore(); // This method calls setLicencesCount, setAzurePlansCount and setSubscriptionTypesCount
          await this.setEstimatedCost();
          this.licencesTableData = await this.setLicencesTableData();
          this.setLicencesUsageChartData();
          this.setBillingPeriod();
          this.setBillingDaysRemaining();
          this.setMonthlyBudget();
          this.setAzurePlansCost();
          this.setAzurePlansUsagePercentage();
          this.azurePlansTableData = this.setAzurePlansTableData();
          if (this.azurePlansCount != 0) {
            this.selectAzurePlan(0); // This method calls setAzurePlanSubscriptionsTableData and setAzureResourcesChartData
          } else {
            this.azurePlanSubscriptionsTableData = [];
            this.azureResourceGroupsTableData = [];
            this.loadedResources = false;
          }
        } catch (error) {
          this.$log.error(`Error loading tenant data: ${error}`);
        } finally {
          this.stopLoading();
        }
      },
      async loadVuexStore() {
        await this.loadAllSubscriptionCSPIdsByCustomerId(
          this.tenantSelected.id
        );
        await this.loadCustomerBillingSummaryCSP(this.tenantSelected.id);
        this.setSubscriptionTypesCount();
        this.setLicencesCount();
        this.setAzurePlansCount();
        if (this.licencesCount != 0) {
          if (config.prodEnv) {
            await this.loadLicencesBillingsCSP(this.tenantSelected.id);
            await this.loadProductSkusCSP(this.tenantSelected.id);
          }
        }
        if (this.azurePlansCount != 0) {
          await this.loadAzureSubscriptionsCSP(this.tenantSelected.id);
          await this.loadAzurePlansUsagesCSP(this.tenantSelected.id);
          await this.loadAzureResourcesCSP(this.tenantSelected.id);
        }
        if (!this.loadedData) {
          this.removeLoadingComponent(this.$options.name); // Remove page loading spinner at the first load only
        }
        this.loadedData = true;
      },
      /* Licences usage chart legend */
      legendClickHandler(index: number): void {
        (
          document.querySelectorAll(
            "#licences-usage-chart .apexcharts-legend-series"
          )[index] as HTMLElement
        ).click();
        $(`.licences-chart-legend-series:nth-child(${index + 1})`).toggleClass(
          "apexcharts-inactive-legend"
        );
      },
      legendHoverHandler(index: number, enter: boolean): void {
        const legendItems = $(
          `#licences-usage-chart .apexcharts-series:not(:nth-child(${index}))`
        );
        const opacityBarsClass = "legend-mouseover-inactive";
        enter
          ? legendItems.addClass(opacityBarsClass)
          : legendItems.removeClass(opacityBarsClass);
      },
      /* Licences usage chart data */
      setLicencesUsageChartData() {
        const filteredProductSkus = this.filterPaidProductSkus();
        if (filteredProductSkus.length == 0) {
          this.loadedProductSkus = false;
        } else {
          this.loadedProductSkus = true;
          filteredProductSkus.sort((a, b) => b.activeUnits - a.activeUnits);
          const columnWidth = 180;
          const chartWidth = filteredProductSkus.length * columnWidth + 80;
          this.licencesUsageChart.width = chartWidth;

          this.licencesUsageChart.chartOptions.xaxis.categories =
            filteredProductSkus.map(sku => sku.name);
          this.licencesUsageChart.series[0].data = filteredProductSkus.map(
            sku => sku.activeUnits
          );
          this.licencesUsageChart.series[1].data = filteredProductSkus.map(
            sku => sku.consumedUnits
          );
          this.licencesUsageChart.series[2].data = filteredProductSkus.map(
            sku => sku.availableUnits
          );
        }
        this.licencesUsageChartKey++;
      },
      // This filters the product SKUs to only include those that have a paid subscription
      filterPaidProductSkus(): Object[] {
        if (this.licencesCount != 0) {
          const productSkus = this.getProductSkusCSP.map(sku => ({
            name: sku.productName,
            activeUnits: sku.activeUnits,
            consumedUnits: sku.consumedUnits,
            availableUnits: sku.availableUnits
          }));

          const filteredProductSkus = productSkus.filter(sku =>
            this.getNonAzurePlanSubscriptionsCSP(this.tenantSelected.id).some(
              subscription => subscription.offerName === sku.name
            )
          );
          return filteredProductSkus;
        } else return [];
      },
      /* Licences table data */
      async setLicencesTableData(): Promise<Object[]> {
        if (this.licencesCount != 0) {
          return Promise.all(
            this.getNonAzurePlanSubscriptionsCSP(this.tenantSelected.id).map(
              async sub => {
                const unitPrice = await this.licenceUnitPrice(sub);
                return {
                  subscription: sub.friendlyName,
                  quantity: sub.quantity + " " + this.$t("licence"),
                  unitCost: "€" + unitPrice.toFixed(2),
                  cost: "€" + (unitPrice * sub.quantity).toFixed(2),
                  status: sub.autoRenewEnabled
                    ? this.$t("autoRenew") +
                      this.formatDate(sub.billingCycleEndDate)
                    : this.$t("expiration") +
                      this.formatDate(sub.billingCycleEndDate)
                };
              }
            )
          );
        } else return [];
      },
      /* Azure plans resume card */
      setBillingPeriod() {
        this.billingPeriod =
          this.formatDateLong(
            this.getCustomerBillingSummaryCSP(this.tenantSelected.id).startDate
          ) +
          " - " +
          this.formatDateLong(
            this.getCustomerBillingSummaryCSP(this.tenantSelected.id).endDate
          );
      },
      setBillingDaysRemaining() {
        const endDateStr = this.getCustomerBillingSummaryCSP(
          this.tenantSelected.id
        ).endDate;
        this.billingDaysRemaining = endDateStr
          ? moment(endDateStr).diff(moment(), "days")
          : 0;
      },
      setMonthlyBudget() {
        const budget = this.getCustomerBillingSummaryCSP(
          this.tenantSelected.id
        ).amount;
        if (budget) {
          this.monthlyBudget = "€" + budget;
        } else {
          this.monthlyBudget = this.$t("undefined");
        }
      },
      setAzurePlansCost() {
        this.azurePlansCost =
          "€" +
          this.getCustomerBillingSummaryCSP(
            this.tenantSelected.id
          ).totalCost.toFixed(2);
      },
      setAzurePlansUsagePercentage() {
        const budget = this.getCustomerBillingSummaryCSP(
          this.tenantSelected.id
        ).amount;
        if (budget) {
          this.azurePlansUsagePercentage =
            (
              (this.getCustomerBillingSummaryCSP(this.tenantSelected.id)
                .totalCost /
                budget) *
              100
            ).toFixed(2) + "%";
        } else {
          this.azurePlansUsagePercentage = this.$t("undefined");
        }
      },
      setAzurePlansTableData(): Object[] {
        const rows = this.getAzurePlanSubscriptionsCSP(
          this.tenantSelected.id
        ).map(sub => {
          const budget = this.getCustomerBillingSummaryCSP(
            this.tenantSelected.id
          ).amount;
          let azPlanCost = 0;
          for (const usage of this.getAzurePlanUsagesCSPByAzurePlanId(sub.id)) {
            azPlanCost += usage.totalCost;
          }
          return {
            azPlanName: sub.offerName,
            azPlanCost: "€" + azPlanCost.toFixed(2),
            azPlanPercentageBudget: budget
              ? "%" + ((azPlanCost / budget) * 100).toFixed(2)
              : this.$t("undefined"),
            azPlanStatus: this.$t(sub.status) // Using given status as i18n key (active, suspended, deleted)
          };
        });
        return rows;
      },
      selectAzurePlan(rowIndex) {
        this.selectedAzPlanIndex = rowIndex;
        this.resourceGroupsSearchFilter = "";
        this.resourceGroupsSubscriptionFilter = [];
        this.azPlanSelectedId = this.getAzurePlanSubscriptionsCSP(
          this.tenantSelected.id
        )[rowIndex].id;
        this.azPlanSelectedName = this.getAzurePlanSubscriptionsCSP(
          this.tenantSelected.id
        )[rowIndex].offerName;
        this.azurePlanSubscriptionsTableData =
          this.setAzurePlanSubscriptionsTableData();
        this.azureResourceGroupsTableData =
          this.setAzureResourceGroupsTableData();
        this.setAzureResourcesChartData();
        this.text.azurePlanResources = `${this.$t("azurePlanResources")} (${
          this.azPlanSelectedName
        })`;
        this.text.azurePlanSubscriptions = `${this.$t(
          "azurePlanSubscriptions"
        )} (${this.azPlanSelectedName})`;
      },
      /* Azure plans subscriptions table */
      setAzurePlanSubscriptionsTableData(): Object[] {
        return this.getAzureSubscriptionsCSPByAzurePlanId(
          this.azPlanSelectedId
        ).map(sub => {
          let entitlementCostSum = 0;
          for (const entitlementUsage of this.getAzurePlanUsagesCSPByEntitlementId(
            sub.id
          )) {
            entitlementCostSum += entitlementUsage.getTotalCost;
          }

          return {
            azPlanSubscriptionId: sub.id,
            azPlanSubscriptionName: sub.azureSubscriptionName,
            azPlanSubscriptionStatus: this.$t(sub.status),
            azPlanSubscriptionCost: "€" + entitlementCostSum.toFixed(2)
          };
        });
      },
      /* Azure plans resource groups table */
      setAzureResourceGroupsTableData(): Object[] {
        const undefinedResourceGroup = this.$t("undefined");
        const normalizeResourceGroupName = (
          resourceGroupName: string
        ): string => resourceGroupName.trim().toLowerCase();

        const usages = this.getAzurePlanUsagesCSPByAzurePlanId(
          this.azPlanSelectedId
        );

        // Create a map of subscription ID to subscription name
        const subscriptionMap = new Map<string, string>();
        this.getAzureSubscriptionsCSPByAzurePlanId(
          this.azPlanSelectedId
        ).forEach(sub => {
          subscriptionMap.set(sub.id, sub.azureSubscriptionName);
        });

        // Single map aggregating all resource group data in one pass
        const resourceGroupDataByNormalized = new Map<
          string,
          {
            displayName: string;
            subscriptionName: string;
            totalCost: number;
          }
        >();

        usages.forEach(usage => {
          const displayName =
            usage.getResourceGroupName || undefinedResourceGroup;
          const normalizedName = normalizeResourceGroupName(displayName);
          const subscriptionName =
            subscriptionMap.get(usage.getEntitlementId) ||
            undefinedResourceGroup;

          if (!resourceGroupDataByNormalized.has(normalizedName)) {
            resourceGroupDataByNormalized.set(normalizedName, {
              displayName,
              subscriptionName,
              totalCost: 0
            });
          }

          const resourceGroupData =
            resourceGroupDataByNormalized.get(normalizedName)!;
          resourceGroupData.totalCost += usage.getTotalCost;
        });

        return Array.from(resourceGroupDataByNormalized.values())
          .map(resourceGroupData => ({
            resourceGroupName: resourceGroupData.displayName,
            resourceGroupSubscriptionName: resourceGroupData.subscriptionName,
            resourceGroupCost: resourceGroupData.totalCost
          }))
          .sort((a, b) => b.resourceGroupCost - a.resourceGroupCost);
      },
      /* Azure plans resources chart */
      loadAzureResources(): { subcategory: string; cost: number }[] {
        return Array.from(
          this.getAzureResourcesCSPByAzurePlanId(this.azPlanSelectedId)
            .reduce((map, resource) => {
              if (!map.has(resource.subcategory)) {
                map.set(resource.subcategory, {
                  subcategory: resource.subcategory,
                  cost: 0
                });
              }
              map.get(resource.subcategory)!.cost += resource.totalCost;
              return map;
            }, new Map<string, { subcategory: string; cost: number }>())
            .values()
        );
      },
      setAzureResourcesChartData() {
        const collapsedResources = this.loadAzureResources();
        if (collapsedResources.length == 0) {
          this.loadedResources = false;
        } else {
          this.loadedResources = true;
          collapsedResources.sort((a, b) => b.cost - a.cost);

          const azureResourcesList = collapsedResources.map(
            resource => resource.subcategory
          );
          const azureResourcesPriceList = collapsedResources.map(resource =>
            resource.cost.toFixed(2)
          );
          const barHeight = 30;
          const chartHeight = azureResourcesList.length * barHeight + 50;
          this.azureResourcesChart.height = chartHeight;

          this.azureResourcesChart.chartOptions.xaxis.categories =
            azureResourcesList;
          this.azureResourcesChart.series[0].data = azureResourcesPriceList;
        }
        this.azureResourcesChartKey++;
      },
      /* Format methods */
      formatDate(dateString: string): string {
        return dateString
          ? new Intl.DateTimeFormat("en-CA").format(new Date(dateString))
          : "";
      },
      formatDateLong(dateString: string): string {
        return dateString
          ? new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric"
            }).format(new Date(dateString))
          : "";
      },
      getUniqueSubscriptions(): string[] {
        return (
          Array.from(
            new Set(
              this.azureResourceGroupsTableData
                .filter(item => item.resourceGroupSubscriptionName)
                .map(item => item.resourceGroupSubscriptionName as string)
            )
          ) as string[]
        ).sort();
      },
      getFilteredResourceGroups(): Object[] {
        let filtered = this.azureResourceGroupsTableData;

        // Filter by search text
        if (this.resourceGroupsSearchFilter) {
          const searchLower = this.resourceGroupsSearchFilter.toLowerCase();
          filtered = filtered.filter(
            item =>
              item.resourceGroupName.toLowerCase().includes(searchLower) ||
              item.resourceGroupSubscriptionName
                .toLowerCase()
                .includes(searchLower)
          );
        }

        // Filter by subscriptions
        if (
          this.resourceGroupsSubscriptionFilter &&
          this.resourceGroupsSubscriptionFilter.length > 0
        ) {
          filtered = filtered.filter(item =>
            this.resourceGroupsSubscriptionFilter.includes(
              item.resourceGroupSubscriptionName
            )
          );
        }

        return filtered;
      },
      onResourceGroupsFilterChange(selectedSubscriptions: string[]): void {
        // Clone to ensure a new reference and trigger reactivity on every change.
        this.resourceGroupsSubscriptionFilter = [...selectedSubscriptions];
      }
    }
  };
